/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
// eslint-disable-next-line react/prop-types
function NewEdit({ width = 27, height = 28, color, isPhoto, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isPhoto && <rect width="72%" height="80%" fill="white" ry="3" />}
      <path
        d="M1.17183 12C0.847473 12 0.571078 11.8718 0.342647 11.6153C0.114216 11.3589 0 11.0486 0 10.6845V2.67194C0 2.30781 0.114216 1.99752 0.342647 1.74107C0.571078 1.48463 0.847473 1.3564 1.17183 1.3564H5.76587L4.59405 2.67194H1.17183V10.6845H8.3091V6.83503L9.48093 5.51951V10.6845C9.48093 11.0486 9.36671 11.3589 9.13828 11.6153C8.90985 11.8718 8.63346 12 8.3091 12H1.17183ZM6.8386 1.7857L7.63417 2.66439L4.25617 6.44629V7.2219H4.93418L8.32198 3.42555L9.10833 4.29732L5.74516 8.07638C5.63636 8.19852 5.51099 8.29438 5.36906 8.36394C5.22714 8.4335 5.07826 8.46827 4.92242 8.46827H3.73185C3.56744 8.46827 3.42868 8.40479 3.31559 8.27783C3.20249 8.15086 3.14594 7.99509 3.14594 7.81051V6.47394C3.14594 6.29899 3.17529 6.13185 3.23398 5.97253C3.29268 5.81319 3.37643 5.67245 3.48523 5.5503L6.8386 1.7857ZM9.10833 4.29732L6.8386 1.7857L8.08012 0.391925C8.31489 0.128358 8.59558 -0.00227343 8.92216 2.99329e-05C9.24876 0.00234294 9.52516 0.135278 9.75135 0.398835L10.3431 1.0742C10.5652 1.33044 10.6763 1.63831 10.6763 1.99783C10.6763 2.35736 10.5632 2.66408 10.337 2.918L9.10833 4.29732Z"
        fill="#043D90"
      />
    </svg>
  );
}
export default NewEdit;
